import React from 'react';

/**
 * AdminSpinner
 * 
 * Standardized loading spinner component for admin pages.
 * 
 * @param {string} size - Spinner size: 'sm' | 'md' | 'lg' (default: 'md')
 * @param {string} color - Spinner color (default: 'var(--color-brand-primary)')
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional styles
 */
export default function AdminSpinner({ 
  size = 'md', 
  color = 'var(--color-brand-primary)',
  className = '',
  style = {}
}) {
  const sizeMap = {
    sm: '16px',
    md: '24px',
    lg: '32px',
  };

  const spinnerSize = sizeMap[size] || sizeMap.md;

  return (
    <div
      className={`admin-loading-spinner ${className}`}
      style={{
        width: spinnerSize,
        height: spinnerSize,
        borderWidth: size === 'sm' ? '2px' : '3px',
        borderColor: `var(--color-border-light)`,
        borderTopColor: color,
        ...style,
      }}
      role="status"
      aria-label="Loading"
    />
  );
}

